import axios from '@axios'

export default {
  listConta: params => axios.get(`${process.env.VUE_APP_NOVITATUS_API}/empresa/contas`, {
    params,
  }),
  listUnidade: params => axios.get(`${process.env.VUE_APP_NOVITATUS_API}/empresa/unidades`, {
    params,
  }),
}
